import React, { useRef } from 'react';
import { useNotification } from '../utils/Notification';
import axios from 'axios';
import { useTranslation } from 'react-i18next';


function Contact() {
  const notification = useNotification()
  const { t } = useTranslation()
  const formRef = useRef(null)

  const sendMail = async (e) => {
    const formElements = formRef.current
    let mail = formElements.querySelector('[name="mail"]')
    let msg = formElements.querySelector('[name="msg"]')

    if(!mail.value || !msg.value) {
      return
    }

    if(!mail.value.includes('@')) {
      return
    }

    const resp = await axios.post(process.env.REACT_APP_API_URL + 'sendEmail', {
      email: mail.value,
      message: msg.value
    })

    if(resp) {
      mail.value = ''
      msg.value = ''
      notification.show('Email succesfully sent')
    }
  }

  return (
    <div className="contact-container" ref={formRef}>
      <h3>{t('contact_us')}</h3>
      <div className="form-group">
        <label>{t('email')}</label>
        <input type="email" name="mail" /> 
      </div>
      <div className="form-group">
        <label>{t('message')}</label>
        <textarea name="msg" /> 
      </div>
      <button className="send-btn" onClick={(e) => sendMail(e)}>{t('send')}</button>
    </div>
  );
}

export default Contact
